module.exports = __webpack_public_path__ + "img/hy8.5838b530.png";